/**
 * Currently, STANDARD_REMOTE_APPLICATIONS is needed to separate apps that should be opened via Remote Application Loader from apps that should be opened via Mfe Wrapper.
 * Once everything is migrated to RAL, STANDARD_REMOTE_APPLICATIONS should be removed.
 * 
 * E.G.
 * Some app uses 'open-application' event
 * MIDC need to know if it should open it via RAL or Mfe Wrapper. So it has to use STANDARD_REMOTE_APPLICATIONS for now
 */
export const STANDARD_REMOTE_APPLICATIONS = ['image-hub'];

export const STANDARD_REMOTE_URL_PREFIX = 'app';
